import VictoryPie from "./components/victory-pie";
export { VictoryPie };


//////////////////
// WEBPACK FOOTER
// ./~/victory-pie/es/index.js
// module id = 1792
// module chunks = 0